<template>
  <div>
    <div id="content" class="yatis-content">
      <div class="wizard">
        <div class="wizard-bar">
          <div class="page">
            <div class="no">
              {{ activeTab }} / {{ Object.keys(tabs).length }}
            </div>
            <div class="head">{{ head }}</div>
          </div>
        </div>

        <div class="wizard-content">
          <form class="p-form" autocomplete="off" v-on:submit.prevent>
            <div v-show="activeTab == 1">
              <div class="labeledit">
                <label for="p-dosya">Dosya No*</label>
                <input
                  type="number"
                  v-model.number.lazy="dosya"
                  id="p-dosya"
                  required
                />
              </div>
              <div class="onceki-yatislar">
                <perfect-scrollbar>
                  <ul v-if="yatis.prevyatis > -1">
                    <div class="baslik">
                      <span class="tarih">Yatış Tarihi</span
                      ><span class="tani">Tanıları</span>
                    </div>
                    <li
                      v-for="o in oncekiler"
                      :key="o.id"
                      :class="yatis.prevyatis == o.id ? 'active' : ''"
                      @click.prevent="oncekiGetir(o.id)"
                    >
                      <span class="tarih">{{
                        o.yatis | moment("DD.MM.YYYY")
                      }}</span
                      ><span class="tani">{{ o.tanilar }}</span>
                    </li>
                  </ul>

                  <div class="empty" v-if="yatis.prevyatis == -1">
                    <div class="small-empty">
                      <i class="fa fa-info-circle fa-3x"></i>
                      <span>Daha önceki yatış bilgisi bulunamadı</span>
                    </div>
                  </div>
                  <div class="empty" v-if="yatis.prevyatis == -2">
                    <div class="small-empty">
                      <i class="fa fa-info-circle fa-3x"></i>
                      <span>Önceki yatışları için Dosya No girin</span>
                    </div>
                  </div>
                </perfect-scrollbar>
              </div>

              <div class="labeledit">
                <label for="p-adi">Adı Soyadı*</label>
                <input type="text" v-model="yatis.adi" id="p-adi" required />
              </div>
              <div class="labeledit">
                <label for="p-kilo">Yatış Kilosu (kg)*</label>
                <input
                  type="number"
                  v-model.number="yatis.kilo"
                  id="p-kilo"
                  step="any"
                  required
                />
              </div>
              <div class="labeledit">
                <label>Cinsiyet*</label>

                <div class="toggle-group">
                  <label for="p-cinsiyet-1">
                    <input
                      id="p-cinsiyet-1"
                      class="modern"
                      type="radio"
                      name="cinsiyet"
                      value="1"
                      required
                      v-model="yatis.cinsiyet"
                    />
                    <span>Erkek</span>
                  </label>
                  <label for="p-cinsiyet-2">
                    <input
                      id="p-cinsiyet-2"
                      class="modern"
                      type="radio"
                      name="cinsiyet"
                      value="2"
                      required
                      v-model="yatis.cinsiyet"
                    />
                    <span>Kız</span>
                  </label>
                </div>
              </div>
              <div class="labeledit">
                <label for="p-dogum">Doğum Tarihi*</label>
                <input
                  type="date"
                  v-model="yatis.dogum"
                  id="p-dogum"
                  required
                />
              </div>

              <div class="labeledit">
                <label>Yatacağı Servis</label>

                <div class="toggle-group vertical">
                  <label for="p-yer-1">
                    <input
                      id="p-yer-1"
                      class="modern"
                      type="radio"
                      value="1"
                      v-model="yatis.yeri"
                    />
                    <span>Genel Servis</span>
                  </label>

                  <label for="p-yer-2">
                    <input
                      id="p-yer-2"
                      class="modern"
                      type="radio"
                      value="2"
                      v-model="yatis.yeri"
                    />
                    <span>Kardiyoloji Servis</span>
                  </label>

                  <label for="p-yer-3">
                    <input
                      id="p-yer-3"
                      class="modern"
                      type="radio"
                      value="3"
                      v-model="yatis.yeri"
                    />
                    <span>Nöroloji Servis</span>
                  </label>

                  <label for="p-yer-4">
                    <input
                      id="p-yer-4"
                      class="modern"
                      type="radio"
                      value="4"
                      v-model="yatis.yeri"
                    />
                    <span>Endokrin Servis</span>
                  </label>

                  <label for="p-yer-5">
                    <input
                      id="p-yer-5"
                      class="modern"
                      type="radio"
                      value="5"
                      v-model="yatis.yeri"
                    />
                    <span>İzole Servis</span>
                  </label>

                  <label for="p-yer-6">
                    <input
                      id="p-yer-6"
                      class="modern"
                      type="radio"
                      value="6"
                      v-model="yatis.yeri"
                    />
                    <span>Yoğun Bakım</span>
                  </label>
                </div>
              </div>
              <div class="labeledit">
                <label for="p-tanilar">Tanı*</label>
                <input
                  type="text"
                  v-model="yatis.tanilar"
                  id="p-tanilar"
                  required
                />
              </div>
              <br />
              <div class="labeledit">
                <label for="p-dr">Yatış Yapan Dr.</label>
                <select id="p-dr" v-model="yatirandr">
                  <option :value="{ id: 0 }">(Yok)</option>
                  <option
                    :value="{ id: d.id, name: d.name }"
                    v-for="d in activedoctors"
                    :key="d.id"
                  >
                    Dr.{{ d.name }}
                  </option>
                </select>
              </div>
            </div>
            <div v-show="activeTab == 2">
              <div class="labeledit">
                <label for="p-sikayet">Şikayetleri</label>
                <input
                  type="text"
                  class="c-input"
                  v-model="yatis.sikayet"
                  id="p-sikayet"
                />
              </div>
              <div class="labeledit vertical">
                <label for="p-gecmis">Hastalık Özgeçmişi</label>
                <input
                  type="text"
                  class="c-input"
                  v-model="yatis.gecmis"
                  id="p-gecmis"
                />
              </div>
              <br />
              <div class="labeledit">
                <textarea
                  spellcheck="false"
                  placeholder="Öykü ve Tetkikler"
                  rows="26"
                  class="c-input"
                  v-model="yatis.oyku"
                ></textarea>
              </div>
            </div>
            <div v-show="activeTab == 3">
              <h4>Genel Durum</h4>
              <div class="toggle-group">
                <label for="gd1">
                  <input
                    id="gd1"
                    class="modern"
                    type="radio"
                    value="İYİ"
                    v-model="muayene.gd"
                  />
                  <span>İyi</span>
                </label>

                <label for="gd2">
                  <input
                    id="gd2"
                    class="modern"
                    type="radio"
                    value="ORTA"
                    v-model="muayene.gd"
                  />
                  <span>Orta</span>
                </label>

                <label for="gd3">
                  <input
                    id="gd3"
                    class="modern"
                    type="radio"
                    value="KÖTÜ"
                    v-model="muayene.gd"
                  />
                  <span>Kötü</span>
                </label>
              </div>

              <h4>Cilt Muayenesi</h4>
              <div class="toggle-group">
                <label for="cilt1">
                  <input
                    id="cilt1"
                    class="modern"
                    type="radio"
                    value="DOĞAL"
                    v-model="muayene.cilt"
                  />
                  <span>Doğal</span>
                </label>

                <label for="cilt2">
                  <input
                    id="cilt2"
                    class="modern"
                    type="radio"
                    value="İKTERİK"
                    v-model="muayene.cilt"
                  />
                  <span>İkterik</span>
                </label>

                <label for="cilt3">
                  <input
                    id="cilt3"
                    class="modern"
                    type="radio"
                    value="DEHİDRATE"
                    v-model="muayene.cilt"
                  />
                  <span>Dehidrate</span>
                </label>
                <label for="cilt4">
                  <input
                    id="cilt4"
                    class="modern"
                    type="radio"
                    value="SOLUK"
                    v-model="muayene.cilt"
                  />
                  <span>Soluk</span>
                </label>
              </div>
              <h4>Baş-Boyun Muayenesi</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="bas1">
                    <input
                      id="bas1"
                      class="modern"
                      type="checkbox"
                      value="SERVİKAL LAP"
                      v-model="muayene.bas"
                    />
                    <span>Servikal LAP (+)</span>
                  </label>

                  <label for="bas2">
                    <input
                      id="bas2"
                      class="modern"
                      type="checkbox"
                      value="SUBMENTAL LAP"
                      v-model="muayene.bas"
                    />
                    <span>Submental LAP (+)</span>
                  </label>

                  <label for="bas3">
                    <input
                      id="bas3"
                      class="modern"
                      type="checkbox"
                      value="SUBMANDİBULAR LAP"
                      v-model="muayene.bas"
                    />
                    <span>Submandibular LAP (+)</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="bas4">
                    <input
                      id="bas4"
                      class="modern"
                      type="checkbox"
                      value="KONJONKTİVİT"
                      v-model="muayene.bas"
                    />
                    <span>Konjonktivit (+)</span>
                  </label>

                  <label for="bas5">
                    <input
                      id="bas5"
                      class="modern"
                      type="checkbox"
                      value="PREORBİTAL ÖDEM"
                      v-model="muayene.bas"
                    />
                    <span>Preorbital Ödem (+)</span>
                  </label>
                  <label for="bas6">
                    <input
                      id="bas6"
                      class="modern"
                      type="checkbox"
                      value="BOYUNDA KİTLE (+)"
                      v-model="muayene.bas"
                    />
                    <span>Boyunda Kitle (+)</span>
                  </label>
                </div>
              </div>
              <h4>Kulak Burun Boğaz Muayenesi</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="kbb1">
                    <input
                      id="kbb1"
                      class="modern"
                      type="checkbox"
                      value="OF HİPEREMİK"
                      v-model="muayene.kbb"
                    />
                    <span>OF Hiperemik</span>
                  </label>

                  <label for="kbb2">
                    <input
                      id="kbb2"
                      class="modern"
                      type="checkbox"
                      value="ORAL AFT (+)"
                      v-model="muayene.kbb"
                    />
                    <span>Oral Aft (+)</span>
                  </label>

                  <label for="kbb3">
                    <input
                      id="kbb3"
                      class="modern"
                      type="checkbox"
                      value="TİMPANİK MEMBRAN HİPEREMİK"
                      v-model="muayene.kbb"
                    />
                    <span>Kulak Zarı Hiperemik</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="kbb4">
                    <input
                      id="kbb4"
                      class="modern"
                      type="checkbox"
                      value="TONSİLLER HİPEREMİK"
                      v-model="muayene.kbb"
                    />
                    <span>Tonsiller Hiperemik</span>
                  </label>

                  <label for="kbb5">
                    <input
                      id="kbb5"
                      class="modern"
                      type="checkbox"
                      value="TONSİLLER HİPERTROFİK"
                      v-model="muayene.kbb"
                    />
                    <span>Tonsiller Hipertrofik</span>
                  </label>

                  <label for="kbb6">
                    <input
                      id="kbb6"
                      class="modern"
                      type="checkbox"
                      value="TONSİLLERDE KRİPT(+)"
                      v-model="muayene.kbb"
                    />
                    <span>Tonsillerde Kript (+)</span>
                  </label>
                </div>
              </div>
              <h4>Solunum Sistemi Muayenesi</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="sol1">
                    <input
                      id="sol1"
                      class="modern"
                      type="radio"
                      value="DOĞAL"
                      v-model="muayene.solunum"
                    />
                    <span>Doğal</span>
                  </label>

                  <label for="sol2">
                    <input
                      id="sol2"
                      class="modern"
                      type="radio"
                      value="TAKİPNEİK"
                      v-model="muayene.solunum"
                    />
                    <span>Takipneik</span>
                  </label>

                  <label for="sol3">
                    <input
                      id="sol3"
                      class="modern"
                      type="radio"
                      value="TAKİPNE VE DİSPNE MEVCUT"
                      v-model="muayene.solunum"
                    />
                    <span>Takipne + Dispne</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="sol4">
                    <input
                      id="sol4"
                      class="modern"
                      type="checkbox"
                      value="KABA"
                      v-model="muayene.ac"
                    />
                    <span>Kaba</span>
                  </label>

                  <label for="sol5">
                    <input
                      id="sol5"
                      class="modern"
                      type="checkbox"
                      value="RAL(+)"
                      v-model="muayene.ac"
                    />
                    <span>Ral (+)</span>
                  </label>

                  <label for="sol6">
                    <input
                      id="sol6"
                      class="modern"
                      type="checkbox"
                      value="RONKUS(+)"
                      v-model="muayene.ac"
                    />
                    <span>Ronküs (+)</span>
                  </label>
                </div>
              </div>
              <h4>Kardiyovasküler Sistem Muayenesi</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="kvs1">
                    <input
                      id="kvs1"
                      class="modern"
                      type="checkbox"
                      value="TAŞİKARDİK"
                      v-model="muayene.kvs"
                    />
                    <span>Taşikardi (+)</span>
                  </label>

                  <label for="kvs2">
                    <input
                      id="kvs2"
                      class="modern"
                      type="checkbox"
                      value="SİYANOZ (+)"
                      v-model="muayene.kvs"
                    />
                    <span>Siyanoz (+)</span>
                  </label>

                  <label for="kvs3">
                    <input
                      id="kvs3"
                      class="modern"
                      type="checkbox"
                      value="ARİTMİK"
                      v-model="muayene.kvs"
                    />
                    <span>Aritmi (+)</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="kvs4">
                    <input
                      id="kvs4"
                      class="modern"
                      type="radio"
                      value="EK SES VE ÜFÜRÜM DUYULMADI"
                      v-model="muayene.ufurum"
                    />
                    <span>Üfürüm yok</span>
                  </label>

                  <label for="kvs5">
                    <input
                      id="kvs5"
                      class="modern"
                      type="radio"
                      value="DİYASTOLİK ÜFÜRÜM (+)"
                      v-model="muayene.ufurum"
                    />
                    <span>Diyastolik</span>
                  </label>

                  <label for="kvs6">
                    <input
                      id="kvs6"
                      class="modern"
                      type="radio"
                      value="SİSTOLİK ÜFÜRÜM (+)"
                      v-model="muayene.ufurum"
                    />
                    <span>Sistolik</span>
                  </label>
                </div>
              </div>
            </div>
            <div v-show="activeTab == 4">
              <h4>Batın Muayenesi</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="batin1">
                    <input
                      id="batin1"
                      class="modern"
                      type="checkbox"
                      value="DEFANS (+)"
                      v-model="muayene.batin"
                    />
                    <span>Defans (+)</span>
                  </label>

                  <label for="batin2">
                    <input
                      id="batin2"
                      class="modern"
                      type="checkbox"
                      value="REBOUND (+)"
                      v-model="muayene.batin"
                    />
                    <span>Rebound (+)</span>
                  </label>

                  <label for="batin3">
                    <input
                      id="batin3"
                      class="modern"
                      type="checkbox"
                      value="HASSASİYET (+)"
                      v-model="muayene.batin"
                    />
                    <span>Hassasiyet (+)</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="batin4">
                    <input
                      id="batin4"
                      class="modern"
                      type="checkbox"
                      value="HEPATOMEGALİ (+)"
                      v-model="muayene.batin"
                    />
                    <span>Hepatomegali (+)</span>
                  </label>

                  <label for="batin5">
                    <input
                      id="batin5"
                      class="modern"
                      type="checkbox"
                      value="SPLENOMEGALİ (+)"
                      v-model="muayene.batin"
                    />
                    <span>Splenomegali (+)</span>
                  </label>
                </div>
              </div>
              <h4>Nörolojik Muayene</h4>
              <div class="toggle-group">
                <label for="noro1">
                  <input
                    id="noro1"
                    class="modern"
                    type="checkbox"
                    value="BİLİNÇ KONFÜZE"
                    v-model="muayene.noro"
                  />
                  <span>Bilinç Konfüze</span>
                </label>

                <label for="noro2">
                  <input
                    id="noro2"
                    class="modern"
                    type="checkbox"
                    value="KAS GÜCÜ 3-4/5"
                    v-model="muayene.noro"
                  />
                  <span>Kas Gücü Zayıf</span>
                </label>

                <label for="noro3">
                  <input
                    id="noro3"
                    class="modern"
                    type="checkbox"
                    value="DTR ALINAMADI"
                    v-model="muayene.noro"
                  />
                  <span>DTR (-)</span>
                </label>

                <label for="noro4">
                  <input
                    id="noro4"
                    class="modern"
                    type="checkbox"
                    value="ENSE SERTLİĞİ MEVCUT"
                    v-model="muayene.noro"
                  />
                  <span>Ense Sertliği</span>
                </label>
              </div>
              <h4>Ekstremite Muayenesi</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="eks1">
                    <input
                      id="eks1"
                      class="modern"
                      type="radio"
                      value="AKTİF HAREKETLİ"
                      v-model="muayene.ekstremite"
                    />
                    <span>Aktif Hareketli</span>
                  </label>

                  <label for="eks2">
                    <input
                      id="eks2"
                      class="modern"
                      type="radio"
                      value="HEMİPLEJİK"
                      v-model="muayene.ekstremite"
                    />
                    <span>Hemiplejik</span>
                  </label>

                  <label for="eks3">
                    <input
                      id="eks3"
                      class="modern"
                      type="radio"
                      value="DİPLEJİK"
                      v-model="muayene.ekstremite"
                    />
                    <span>Diplejik</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="eks4">
                    <input
                      id="eks4"
                      class="modern"
                      type="checkbox"
                      value="PALPABL PURPURA (+)"
                      v-model="muayene.eks"
                    />
                    <span>Palpabl Purpura (+)</span>
                  </label>

                  <label for="eks5">
                    <input
                      id="eks5"
                      class="modern"
                      type="checkbox"
                      value="YAYGIN ÜRTİKER"
                      v-model="muayene.eks"
                    />
                    <span>Yaygın Ürtiker</span>
                  </label>

                  <label for="eks6">
                    <input
                      id="eks6"
                      class="modern"
                      type="checkbox"
                      value="ARTRİT (+)"
                      v-model="muayene.eks"
                    />
                    <span>Artrit (+)</span>
                  </label>
                </div>
              </div>
              <h4>Ürogenital Sistem Muayenesi</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="uro1">
                    <input
                      id="uro1"
                      class="modern"
                      type="radio"
                      value="HARİCEN ERKEK"
                      v-model="muayene.urogenital"
                    />
                    <span>Haricen Erkek</span>
                  </label>

                  <label for="uro2">
                    <input
                      id="uro2"
                      class="modern"
                      type="radio"
                      value="HARİCEN KIZ"
                      v-model="muayene.urogenital"
                    />
                    <span>Haricen Kız</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="uro3">
                    <input
                      id="uro3"
                      class="modern"
                      type="checkbox"
                      value="KVAH (+)"
                      v-model="muayene.uro"
                    />
                    <span>KVAH (+)</span>
                  </label>

                  <label for="uro4">
                    <input
                      id="uro4"
                      class="modern"
                      type="checkbox"
                      value="SUPRAPUBİK HASSASİYET (+)"
                      v-model="muayene.uro"
                    />
                    <span>Suprapubik Hassasiyet</span>
                  </label>
                </div>
              </div>
              <h4>Öneriler</h4>
              <div class="multi-toggle-group">
                <div class="toggle-group vertical">
                  <label for="oneri1">
                    <input
                      id="oneri1"
                      class="modern"
                      type="checkbox"
                      value="MONİTÖRİZASYON"
                      v-model="oneri"
                    />
                    <span>Monitörizasyon</span>
                  </label>

                  <label for="oneri2">
                    <input
                      id="oneri2"
                      class="modern"
                      type="checkbox"
                      value="İDAME MAYİ"
                      v-model="oneri"
                    />
                    <span>İdame Mayi</span>
                  </label>

                  <label for="oneri3">
                    <input
                      id="oneri3"
                      class="modern"
                      type="checkbox"
                      value="FAMOTİDİN"
                      v-model="oneri"
                    />
                    <span>Famotidin</span>
                  </label>

                  <label for="oneri4">
                    <input
                      id="oneri4"
                      class="modern"
                      type="checkbox"
                      value="SEFTRİAKSON"
                      v-model="oneri"
                    />
                    <span>Seftriakson</span>
                  </label>

                  <label for="oneri5">
                    <input
                      id="oneri5"
                      class="modern"
                      type="checkbox"
                      value="ENFLUVİR"
                      v-model="oneri"
                    />
                    <span>Enfluvir</span>
                  </label>

                  <label for="oneri6">
                    <input
                      id="oneri6"
                      class="modern"
                      type="checkbox"
                      value="KLARİTROMİSİN"
                      v-model="oneri"
                    />
                    <span>Klaritromisin</span>
                  </label>

                  <label for="oneri7">
                    <input
                      id="oneri7"
                      class="modern"
                      type="checkbox"
                      value="AMOKLAVİN"
                      v-model="oneri"
                    />
                    <span>Amoklavin</span>
                  </label>
                </div>
                <div class="toggle-group vertical">
                  <label for="oneri8">
                    <input
                      id="oneri8"
                      class="modern"
                      type="checkbox"
                      value="PAROL"
                      v-model="oneri"
                    />
                    <span>Parol</span>
                  </label>

                  <label for="oneri9">
                    <input
                      id="oneri9"
                      class="modern"
                      type="checkbox"
                      value="IBUPROFEN"
                      v-model="oneri"
                    />
                    <span>Ibuprofen</span>
                  </label>

                  <label for="oneri10">
                    <input
                      id="oneri10"
                      class="modern"
                      type="checkbox"
                      value="ANTEPSİN"
                      v-model="oneri"
                    />
                    <span>Antepsin</span>
                  </label>

                  <label for="oneri11">
                    <input
                      id="oneri11"
                      class="modern"
                      type="checkbox"
                      value="MAFLOR"
                      v-model="oneri"
                    />
                    <span>Maflor</span>
                  </label>

                  <label for="oneri12">
                    <input
                      id="oneri12"
                      class="modern"
                      type="checkbox"
                      value="ZINCO"
                      v-model="oneri"
                    />
                    <span>Zinco</span>
                  </label>

                  <label for="oneri13">
                    <input
                      id="oneri13"
                      class="modern"
                      type="checkbox"
                      value="ERİSTROSİT SÜSPANSİYONU"
                      v-model="oneri"
                    />
                    <span>Eritrosit Süspansiyonu</span>
                  </label>

                  <label for="oneri14">
                    <input
                      id="oneri14"
                      class="modern"
                      type="checkbox"
                      value="TROMBOSİT SÜSPANSİYONU"
                      v-model="oneri"
                    />
                    <span>Trombosit Süspansiyonu</span>
                  </label>
                </div>
              </div>
            </div>
            <div v-show="activeTab == 5">
              <h4>Muayene</h4>
              <div class="labeledit">
                <textarea
                  placeholder="Muayene"
                  spellcheck="false"
                  rows="13"
                  class="c-input"
                  v-model="sonuc.muayene"
                ></textarea>
              </div>
              <br />
              <h4>Öneriler</h4>
              <div class="labeledit">
                <textarea
                  placeholder="Öneriler"
                  spellcheck="false"
                  rows="13"
                  class="c-input"
                  v-model="sonuc.oneri"
                ></textarea>
              </div>
            </div>

            <div class="wizard-buttons">
              <button
                class="btn btn-blue fr"
                v-show="next"
                @click="navigate(1)"
              >
                <i class="fa fa fa-angle-right"></i> Devam Et
              </button>
              <button
                class="btn btn-blue fl"
                v-show="prev"
                @click="navigate(-1)"
              >
                <i class="fa fa fa-angle-left"></i> Geri
              </button>

              <button
                class="btn btn-green fr"
                v-show="activeTab == 5"
                @click="yatir()"
              >
                <i class="fa fa fa-check"></i> Yatışı Tamamla
              </button>
              <button
                class="btn btn-indigo fr"
                v-show="activeTab == 5"
                @click="print()"
              >
                <i class="fa fa fa-print"></i> Yazdır
              </button>
            </div>
          </form>
        </div>
      </div>
      <div id="printArea" class="p-not">
        <p>
          <center>
            <b>YATIŞ NOTU</b>
          </center>
        </p>
        <p style="text-align: right">
          <b>{{ new Date() | moment("DD.MM.YYYY") }}</b>
        </p>
        <p>
          <b
            >{{ yatis.adi | toUpperCase }} ({{ yatis.cinsiyet | toSex }},
            {{ yatis.dogum | toYas }}, {{ yatis.kilo }} KG)</b
          >
        </p>
        <p>ŞİKAYET : {{ yatis.sikayet | toUpperCase }}</p>
        <p>{{ yatis.gecmis | toUpperCase }}</p>
        <p>{{ yatis.oyku | toUpperCase }}</p>
        <ul>
          <li v-for="m in muayeneler" :key="m">
            {{ m | toUpperCase }}
          </li>
        </ul>
        <p>
          HASTANIN İLERİ TETKİK VE TEDAVİ AMACIYLA KONSÜLTAN ÖĞRETİM GÖREVLİSİNE
          DANIŞILARAK {{ yeri | toUpperCase }} YATIŞI YAPILDI.
        </p>
        <p>ÖNERİLER</p>
        <ul>
          <li v-for="o in oneriler" :key="o">
            {{ o | toUpperCase }}
          </li>
        </ul>
        <p style="text-align: right">
          <b>{{ yatirandr.id > 0 ? "Dr." + yatirandr.name : "" }}</b>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "NewServis",
  data() {
    return {
      activeTab: 1,
      tabs: {
        1: "Hasta Bilgileri",
        2: "Anamnez ve Öykü",
        3: "Muayeneler",
        4: "Muayene ve Öneriler",
        5: "Yatış Notu",
      },
      dosya: "",
      oncekiler: [],
      yatis: {
        adi: "",
        cinsiyet: "-1",
        yeri: "1",
        prevyatis: -2,
        kilo: "",
        boy: "",
        bas: "",
        dogum: "",
        sikayet: "",
        oyku: "",
        gecmis: "BİLİNEN HASTALIK ÖYKÜSÜ YOK. DÜZENLİ İLAÇ KULLANIMI YOK.",
        tanilar: "",
        dr: null,
      },
      ozgecmis: "",
      soygecmis: "",
      taburcu: `1. BESLENME VE AŞILAR ANLATILDI.
2. HASTAYA 3 GÜN SONRA ÇOCUK SAĞLIĞI VE HASTALIKLARI POLİKLİNİK KONTROLÜ ÖNERİLDİ.
3. AİLE HEKİMLİĞİ VE ÇOCUK SAĞLIĞI POLİKLİNİK TAKİPLERİ ÖNERİLDİ.
4. ACİL DURUMLAR ANLATILDI. DURUM DEĞİŞİKLİĞİ HALİNDE DERHAL ACİL SERVİSE BAŞVURMALARI GEREKTİĞİ ANLATILDI.`,
      muayene: {
        gd: "İYİ",
        cilt: "DOĞAL",
        bas: [],
        kbb: [],
        solunum: "DOĞAL",
        ac: [],
        kvs: [],
        ufurum: "EK SES VE ÜFÜRÜM DUYULMADI",
        batin: [],
        noro: [],
        ekstremite: "AKTİF HAREKETLİ",
        eks: [],
        urogenital: "HARİCEN ERKEK",
        uro: [],
      },
      oneri: [],
      sonuc: {
        muayene: "",
        oneri: "",
      },
    };
  },
  watch: {
    muayene: {
      deep: true,
      immediate: true,
      handler: function() {
        var r = [];
        r.push("GENEL DURUMU " + this.muayene.gd);
        r.push("CİLT " + this.muayene.cilt + " GÖRÜNÜMDE");
        if (!this.muayene.bas.length) {
          r.push("BAŞ-BOYUN : DOĞAL, LAP GÖRÜLMEDİ");
        } else {
          r.push("BAŞ-BOYUN : " + this.muayene.bas + " MEVCUT");
        }
        if (!this.muayene.kbb.length) {
          r.push("KBB : OF DOĞAL, TONSİLLER DOĞAL GÖRÜLDÜ");
        } else {
          r.push("KBB : " + this.muayene.kbb + " GÖRÜLDÜ");
        }
        if (!this.muayene.ac.length) {
          r.push(
            "SOLUNUM SİSTEMİ : " + this.muayene.solunum + ". AC SESLERİ DOĞAL"
          );
        } else {
          r.push(
            "SOLUNUM SİSTEMİ : " +
              this.muayene.solunum +
              ". AC SESLERİ " +
              this.muayene.ac
          );
        }
        if (!this.muayene.kvs.length) {
          r.push("KVS : S1(+) S2(+) " + this.muayene.ufurum);
        } else {
          r.push(
            "KVS : S1(+) S2(+) " + this.muayene.kvs + ". " + this.muayene.ufurum
          );
        }
        if (!this.muayene.batin.length) {
          r.push(
            "BATIN : BATIN RAHAT. DEFANS, REBOUND VE HASSASİYET YOK. HSM GÖRÜLMEDİ"
          );
        } else {
          r.push("BATIN : " + this.muayene.batin);
        }
        if (!this.muayene.noro.length) {
          r.push("NÖROLOJİK : BİLİNÇ AÇIK. ENSE SERTLİĞİ YOK. KAS GÜCÜ 5/5");
        } else {
          r.push("NÖROLOJİK : " + this.muayene.noro);
        }
        if (!this.muayene.eks.length) {
          r.push("EKSTREMİTELER : " + this.muayene.ekstremite);
        } else {
          r.push(
            "EKSTREMİTELER : " +
              this.muayene.ekstremite +
              ". " +
              this.muayene.eks
          );
        }
        if (!this.muayene.uro.length) {
          r.push("ÜROGENİTAL : " + this.muayene.urogenital);
        } else {
          r.push(
            "ÜROGENİTAL : " + this.muayene.urogenital + ". " + this.muayene.uro
          );
        }
        this.sonuc.muayene = r.join("\n");
      },
    },
    yatis: {
      deep: true,
      immediate: false,
      handler: function() {
        var r;
        switch (this.yatis.cinsiyet) {
          case "1":
            r = "HARİCEN ERKEK";
            break;
          case "2":
            r = "HARİCEN KIZ";
            break;
          case "-1":
            r = "";
            break;
        }
        this.muayene.urogenital = r;
      },
    },

    dosya: {
      deep: false,
      immediate: false,
      handler: function() {
        this.$http({
          method: "post",
          url: "api/search.php",
          data: qs.stringify({
            dosya: this.dosya,
            q: "servis-yatis",
          }),
        }).then((request) => {
          if (request.data.data.patient != false) {
            this.$snotify.info("Bir önceki yatış notları getirildi");
            this.oncekiler = request.data.data.patient;
            this.oncekiGetir(-1);
          } else {
            this.yatis.prevyatis = -1;
          }
        });
      },
    },
    oneri: function() {
      this.sonuc.oneri = this.oneri.join("\n");
    },
  },
  computed: {
    yatirandr: {
      get() {
        var r;
        if (this.yatis.dr === null) {
          if (this.user.level == 0) {
            r = { id: 0 };
          } else {
            r = { id: this.user.id, name: this.user.name };
          }
        } else {
          r = this.yatis.dr;
        }
        return r;
      },
      set(val) {
        this.yatis.dr = val;
      },
    },
    user() {
      return this.$store.getters.getUser;
    },
    doctors() {
      return this.$store.getters.getDoctors;
    },
    activedoctors() {
      return this.$store.getters.getActiveDoctors;
    },
    head() {
      return this.tabs[this.activeTab];
    },
    prev() {
      return this.activeTab > 1 ? true : false;
    },
    next() {
      return this.activeTab < 5 ? true : false;
    },
    yeri() {
      return this.$store.getters.getServis(this.yatis.yeri);
    },
    muayeneler() {
      return this.sonuc.muayene.split("\n");
    },
    oneriler() {
      return this.sonuc.oneri.split("\n");
    },
  },
  methods: {
    oncekiGetir(id) {
      var kayit;
      if (id == -1) {
        kayit = this.oncekiler[0];
      } else {
        kayit = this.oncekiler.find((t) => t.id === id);
      }
      this.yatis.prevyatis = kayit.id;
      this.yatis.adi = kayit.name;
      this.yatis.cinsiyet = kayit.sex;
      this.yatis.kilo = kayit.kg;
      this.yatis.boy = kayit.boy;
      this.yatis.bas = kayit.bas;
      this.sonuc.muayene = kayit.muayene;
      this.yatis.dogum = kayit.birth;
      this.yatis.tanilar = kayit.tanilar;
      this.yatis.sikayet = kayit.sikayet;
      this.yatis.oyku = kayit.oyku;
      this.yatis.gecmis = kayit.gecmis;
      this.sonuc.oneri = kayit.oneriler;
      this.yatis.yeri = kayit.yeri;
      this.ozgecmis = kayit.ozgecmis;
      this.soygecmis = kayit.soygecmis;
    },

    validateEmpty(list) {
      let r = true;
      list.forEach((item) => {
        if (item == "") {
          r = false;
        }
      });
      return r;
    },
    validateDate(list) {
      let r = true;
      list.forEach((item) => {
        if (!this.$moment(item).isValid()) {
          r = false;
        }
      });
      return r;
    },
    navigate(step) {
      if (this.activeTab + step != 6 || this.activeTab + step != 0) {
        if (
          !this.validateEmpty([
            this.dosya,
            this.yatis.adi,
            this.yatis.kilo,
            this.yatis.tanilar,
          ]) ||
          !this.validateDate([this.yatis.dogum]) ||
          this.yatis.cinsiyet == "-1"
        ) {
          this.$snotify.warning("Zorunlu alanları girmeden devam edemezsiniz");
        } else {
          this.activeTab = this.activeTab + step;
        }
      }
    },
    yatir() {
      this.$http({
        method: "post",
        url: "api/add-patient.php",
        data: qs.stringify({
          yeri: this.yatis.yeri,
          dosya: this.dosya,
          name: this.yatis.adi,
          sex: this.yatis.cinsiyet,
          birth: this.yatis.dogum,
          tanilar: this.yatis.tanilar,
          kg: this.yatis.kilo,
          boy: this.yatis.boy,
          bas: this.yatis.bas,
          sikayet: this.yatis.sikayet,
          gecmis: this.yatis.gecmis,
          ozgecmis: this.ozgecmis,
          soygecmis: this.soygecmis,
          oneriler: this.sonuc.oneri,
          taburcu: this.taburcu,
          oyku: this.yatis.oyku,
          muayene: this.sonuc.muayene,
          dr: this.yatirandr.id,
        }),
      })
        .then((r) => {
          if (r.data.result == "200") {
            this.$snotify.success("Yatış işlemi başarılı");
            this.$store.dispatch("fillPatients");
            this.$socket.client.emit(
              "yatis",
              this.yatis.adi,
              this.yatis.tanilar
            );
            const userId = r.data.id;
            this.$router.push({
              path: `/patients/servis/${userId}`,
            });
          } else {
            this.$snotify.error("Hata : " + r.data.error);
          }
        })
        .catch((e) => this.$snotify.error("Hata : " + e));
    },
    print() {
      const options = {
        name: "_blank",
        specs: ["height=800", "height=800", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://pediatrim.net/print/yatis.css"],
      };
      this.$htmlToPaper("printArea", options);
    },
  },
};
</script>

<style lang="scss">
div.onceki-yatislar {
  display: block;
  margin: 13px 3px;
  height: 180px;
  .ps {
    max-height: 180px;
  }
  ul {
    list-style-type: none;
    width: 100%;
    border: 1px solid $gray-400;
    background-color: white;
    span.tarih {
      flex: 0 0 100px;
      text-align: center;
    }
    span.tani {
      flex: 1 0 auto;
    }
    div.baslik {
      font-weight: bold;
      display: flex;
      line-height: 22px;
      background-color: $gray-200;
    }
    li {
      display: flex;
      border-top: 1px solid $gray-200;
      line-height: 18px;
      padding: 3px;
      font-size: 12px;
      cursor: pointer;
      &.active {
        color: black !important;
        background-color: transparentize($blue, 0.8) !important;
      }
      &:hover {
        background-color: transparentize($primary, 0.9) !important;
      }
    }
  }
  .small-empty {
    border: 1px solid $gray-300;
    background-color: white;
    padding: 68px 0;
  }
}
</style>
